import React, { useState, useEffect, useRef } from "react";
import useTable from "../useTable";
import { Mensaje, MensajeSiNo } from "../mensajes2";
import { Dimmer } from "../spinner";
import axios from "axios";
import moment from "moment";
//import { ModalEnviarSolicitudTrasladoFondos } from "./modalEnviarSolicitudTraslado";
import { Input } from "../../ui/inputs/Input";
import { PrimaryButton } from "../../ui/buttons/Button";
import { ModalTrasladoFondos } from "./modalSolicitudTraladoFondos";
import { ModalEnviarSolicitudTrasladoFondos } from "./modalEnviarSolicitudTraslado";

const TablaEnviarSolicitudTraslado = (props) => {
  var op = require("../../../src/modulos/datos");
  let token = localStorage.getItem("jwtToken");
  const idefiscal = JSON.parse(localStorage.getItem("idefiscal"));
  const espiritu = JSON.parse(localStorage.getItem("espiritu"));

  const headCells = [
    {
      id: "1",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "N° CONTROL",
      textAlign: "center",
    },
    {
      id: "2",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "DESCRIPCIÓN",
      textAlign: "center",
    },
    {
      id: "3",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "FECHA",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "CODIGO",
      textAlign: "center",
    },
    {
      id: "4",
      backgroundColor: "rgba(5, 81, 130, 1)",
      color: "#ffffff",
      label: "OPCIONES",
      textAlign: "center",
    },
  ];

  const [mostrar2, setMostrar2] = useState(false);
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [mensajesino, setMensajesino] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [activate, setActivate] = useState(false);
  const [records, setRecords] = useState([]);
  const [operacion, setOperacion] = useState(0);
  const [aprob] = useState(true);
  const [aprobaciones, setAprobaciones] = useState();
  const [aprodetalle, setAprodetalle] = useState();
  const [norden, setNorden] = useState(true);
  const txtBuscador = useRef();
  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  const { TblContainer, TblHead, recordsAfterPagingAndSorting, TblPagination } =
    useTable(records, headCells, filterFn);
  const handleSearch = (e) => {
    let target = e.target;
    setFilterFn({
      fn: (items) => {
        if (target.value === "") return items;
        else
          return items.filter((x) => {
            if (
              (x.idaprobaciones !== null
                ? x.idaprobacion
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "") ||
              (x.fodoterceroaprob !== null
                ? x.idaprobacion
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "") ||
              (x.observaciones !== null
                ? x.descripaprobacion
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "") ||
              (x.fecha !== null
                ? moment.utc(x.fecha)
                    .format("DD/MM/YYYY")
                    .toLowerCase()
                    .includes(target.value.toLowerCase())
                : "")
            ) {
              return x;
            }
          });
      },
    });
  };

  const seleccionarRegistros = () => {
    let endpoint = `${op.conexion}/api/administracion/trasladosaprobados?idefiscal=${idefiscal}&devuelto=${props.devolver}`;
    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          setRecords(response.data);
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const seleccionarSolicitudesApro = (id) => {
    let campos = "*";
    let nomtab = "aprobaciones";
    let nomid = "idaprobaciones";
    let nomid2 = "tipo";
    let id2 = 4;
    let nomid3 = "devuelto";
    let id3 = props.devolver;
    let nomid4 = "efiscal";
    let id4 = idefiscal;
    let endpoint = `${op.conexion}/api/consulta/modeli7?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${id2}&nomid3=${nomid3}&id3=${id3}&nomid4=${nomid4}&id4=${id4}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data[0]) {
            setAprobaciones(response.data[0]);
            seleccionarSolicitudesAproDetalles(id);
          } else {
            setAprobaciones();
            seleccionarSolicitudesAproDetalles(id);
          }
          setActivate(false);
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const seleccionarSolicitudesAproDetalles = (id) => {
    let endpoint = `${op.conexion}/api/administracion/detallesolicitudtraslado?id=${id}&idefiscal=${idefiscal}`;
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data.length > 0) {
            setAprodetalle(response.data);
            setMostrar2(true);
          } else {
            setAprodetalle();
            setMostrar2(true);
          }
        }
      })
      .catch((error) => {
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
        setActivate(false);
      });
  };

  const handleCloseSi = () => {
    setActivate(false);
  };

  const gestionarOrdenPago = (op, data) => (e) => {
    if (op === 4) {
      setOperacion(4);

      seleccionarSolicitudesApro(data.idaprobaciones);
    } else if (op === 1) {
      setOperacion(op);
      setMostrar2(true);
    } else if (op === 2) {
      setOperacion(op);

      seleccionarSolicitudesApro(data.idaprobaciones);
    }
  };

  useEffect(() => {
    if (espiritu === 0 || espiritu === 2 || espiritu === 3 || espiritu === 4) {
      setNorden(false);
    }
    seleccionarRegistros();
    setActivate(true);
  }, [props.tabla]);

  const handleCancelar = () => {
    setMostrar2(false);
  };

  const cerrar = () => {
    props.setTabla(0);
  };

  return (
    <div className="col-8 m-0 p-0 mx-auto mt-5">
      <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between rounded-top azulGradiant text-light">
        <h3 className="m-0">
          {"Gestionar " + (props.devolver === '1' ? "Envios" : "Devoluciones") + " de Solicitud Traslado Fondos de Terceros"}
        </h3>
        <a type="button" onClick={cerrar}>
          salir<i className="fas fa-times ms-2"></i>
        </a>
      </header>
      <form
        onSubmit={(e) => {
          e.preventDefault();
        }}
        className="col-12 m-0 p-2 d-flex justify-content-between"
      >
        <div className="col-4 m-0 p-0">
          <input
            ref={txtBuscador}
            onChange={handleSearch}
            placeholder="Buscar"
            className='search-input form-control form-control-sm' />
        </div>
        <PrimaryButton
          onClick={gestionarOrdenPago(1, "")}
          icon="fa-plus m-0"
        ></PrimaryButton>
      </form>
      <div>
        <TblContainer>
          <TblHead />
          <tbody>
            {records &&
              recordsAfterPagingAndSorting().map((item, index) => (
                <tr key={index} style={{ padding: "0" }}>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "30px",
                    }}
                  >
                    {item.fodoterceroaprob}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "300px",
                    }}
                  >
                    {item.observaciones}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {moment.utc(item.fecha).format("DD/MM/YYYY")}
                  </td>
                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "50px",
                    }}
                  >
                    {item.idaprobaciones}
                  </td>

                  <td
                    className="align-baseline"
                    style={{
                      textAlign: "center",
                      alignItems: "center",
                      width: "100px",
                    }}
                  >
                    <button
                      onClick={gestionarOrdenPago(4, item)}
                      className="btn btn-sm mx-1 btn-info rounded-circle"
                    >
                      <i className="fas fa-eye"></i>
                    </button>
                  </td>
                </tr>
              ))}
          </tbody>
        </TblContainer>
        <TblPagination />
      </div>
      <ModalEnviarSolicitudTrasladoFondos
        show={mostrar2}
        operacion={operacion}
        norden={norden}
        aprobado={aprob}
        ubica={1}
        tipo={1}
        tipocom={4}
        devolver={props.devolver}
        aprobaciones={aprobaciones}
        aprodetalle={aprodetalle}
        onHideCancela={handleCancelar}
        onHideRenderizar={seleccionarRegistros}
      />
      <Mensaje
        mensaje={mensaje}
        onHide={() =>
          setMensaje({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
      />
      <MensajeSiNo
        mensaje={mensajesino}
        onHideNo={() =>
          setMensajesino({ mostrar: false, titulo: "", texto: "", icono: "" })
        }
        onHideSi={handleCloseSi}
      />

      <Dimmer active={activate} inverted></Dimmer>
    </div>
  );
};
export default TablaEnviarSolicitudTraslado;
